import { render, staticRenderFns } from "./MantenimientoContratoModal.vue?vue&type=template&id=b066ef50"
import script from "./MantenimientoContratoModal.vue?vue&type=script&lang=js"
export * from "./MantenimientoContratoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports